import styled from 'styled-components';

export const SelectsWrap = styled.div`
  width: 100%;
  padding: 24px 0;
  box-sizing: border-box;
`;
